<template>
    <div class="body">
        <MenuPage></MenuPage>
        <Dialog v-model:visible="spinnervisible" modal :closable="false" class="alrt">
            <div>
                <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                    fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />

                <p>{{ texto }}</p>
            </div>
        </Dialog>




        <div class="content">
            <DataTable :value="almacenes" dataKey="Id" paginator :rows="7" scrollable scrollHeight="60vh"
                v-model:filters="filters">
                <template #header>
                    <div class="table-header flex gap-2">
                        <h3>ALMACEN APIZACO</h3>
                        <Button label="Salida de Almacen" icon="pi pi-sort-up-fill" class="p-button-info"
                            @click="PasarLlenado" v-if="puntos.length !== 0 & statusgen === 'vacio'" />
                        <Button label="Entrada Almacen Indeasa" icon="pi pi-external-link" class="p-button-info" @click="PasarSalida"
                            v-if="puntos.length !== 0 & (statusgen === 'transito' || statusgen === 'lleno')" />
                    </div>
                </template>


                <Column headerStyle="width:3rem">
                    <template #body="{ data }">
                        <Checkbox @change="Checkstatus(`${data.Estatus}`)" v-model="puntos" :value="data" />
                    </template>
                </Column>


                <Column field="Numero_unico" header="Número único" style="min-width:12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar número" />
                    </template>
                </Column>

                <Column field="orden" header="Orden Servicio" style="min-width:12rem">
                    <template #body="{ data }">
                        <div class="order-number">
                            {{ data.orden }}
                        </div>

                    </template>
                </Column>

                <Column field="orden_llenado" header="Orden Apizaco" style="min-width:12rem">
                    <template #body="{ data }">
                        <div class="order-number2">
                            {{ data.orden_llenado }}
                        </div>

                    </template>
                </Column>

                <Column field="cliente" header="Cliente" style="min-width:12rem">
                    <template #body="{ data }">
                        {{ data.cliente }}
                    </template>
                </Column>


                <Column field="producto" header="Producto" style="min-width:12rem">
                    <template #body="{ data }">
                        {{ data.producto }}
                    </template>
                </Column>

                <Column field="Estatus" header="Estatus" style="min-width:12rem">
                    <template #body="{ data }">
                        <div class="customfilter bg_admin" v-if="data.Estatus === 'vacio'">
                            {{ data.Estatus }}
                        </div>
                        <div class="customfilter bg_operador" v-if="data.Estatus === 'transito' || data.Estatus === 'lleno'">
                            transito
                        </div>
                        <div class="customfilter bg_facturacion" v-if="data.Estatus === 'completo'">
                            {{ data.Estatus }}
                        </div>
                    </template>
                </Column>
            </DataTable>

        </div>
    </div>
</template>


<script setup>
import api from '@/plugins/axios';
import MenuPage from '../MenuPage.vue';
import InputText from 'primevue/inputtext';
import { onMounted, ref } from 'vue';
// import FloatLabel from 'primevue/floatlabel';
import { Dialog, Column, DataTable, Button, ProgressSpinner, Checkbox } from 'primevue';
// import { useToast } from 'vue-toastification';
import { nextTick } from 'vue';
import { useToast } from 'vue-toastification';

const puntos = ref([]);
const statusgen = ref("");
const texto = ref("Cargando Items");
const error = ref("");

const filters = ref({
    global: { value: null },
    Numero_unico: { value: null, matchMode: 'contains' },
    Estatus: { value: null, matchMode: 'contains' },
    orden: { value: null, matchMode: 'contains' },
});

const almacenes = ref([]);
const spinnervisible = ref(true);
const toast = useToast();

const getItems = async () => {
    try {
        const res = await api.get("/almacen/getalmacen/apizaco");
        console.log(res.data)
        almacenes.value = res.data ?? [];
        nextTick(() => {
            setTimeout(() => {
                spinnervisible.value = false;
            }, 1000);
        });
    }
    catch (err) {
        console.error(err);
    }
}


const PasarLlenado = async () => {
    try {
        if (error.value !== "error") {
            spinnervisible.value = true;
            texto.value = "Llenando";
            const res = await api.post("/almacen/llenaritems", {
                Items: JSON.stringify(puntos.value),
                usuario: localStorage.getItem("nombre")
            });
            console.log(res.data);
            if (res.data.response === 'success') {
                setTimeout(async () => {
                    await getItems();
                    toast.success("Items llenados con exito");
                    puntos.value = [];
                    statusgen.value = "";
                    spinnervisible.value = false;
                }, 1000);
            }
            else {
                spinnervisible.value = false;
            }
        }
        else
        {
            toast.error("No puedes llenar items ya llenos")
        }
    }
    catch (err) {
        console.error(err);
        spinnervisible.value = false;
    }
}

const Checkstatus = (estatus) => {
    error.value = "";
    if (statusgen.value == "") {
        statusgen.value = estatus;
        return;
    }
    else if (puntos.value.length === 0) {
        statusgen.value = "";
        return true;
    }

    if (statusgen.value === estatus) {
        return true;
    }
    else {
        toast.error("Selecciona items con estatus iguales");
        error.value = "error";
        statusgen.value = "";
        puntos.value=[];
        return false;
    }
}


const PasarSalida = async () => {
    try {
        if (error.value !== "error") {
            const res = await api.post("/almacen/pasarsalida", {
                items: JSON.stringify(puntos.value),
                user: localStorage.getItem("nombre")
            });
            console.log(res.data);
            if (res.data.response === 'success') {
                await getItems();
                toast.success("Items pasados a la planta de lleado con exito");
            }
        }
        else {
            toast.error("No puedes sacar items no llenados");
        }
    }
    catch (err) {
        console.error(err);
    }
}


onMounted(async () => {
    await getItems();

});



</script>


<style scoped>
.customfilter {
    width: 100px;
    border-radius: 5px;
    text-align: center;
    padding: 2px;
}

.bg_admin {
    background: rgba(0, 136, 255, 0.362);
    color: rgb(0, 140, 255);
}

.bg_facturacion {
    background: rgb(255, 183, 0);
    color: rgb(255, 255, 255);
}

.bg_operador {
    background: rgba(0, 196, 49, 0.362);
    color: rgb(17, 114, 0);
}

.order-number {
    width: 90%;
    background: rgb(0, 92, 192);
    color: white;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    border: 1px solid rgb(0, 92, 192);
    border-radius: 12px;
    box-shadow: 0px 4px 0px silver;
    padding: 10px;
}


.order-number2 {
    width: 90%;
    background: rgb(1, 139, 105);
    color: white;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    border: 1px solid rgb(0, 92, 192);
    border-radius: 12px;
    box-shadow: 0px 4px 0px silver;
    padding: 10px;
}
</style>